import { isServer } from 'src/libs/helper'
import { ProfileRepository } from 'src/repositories'
import { ProfileEntity } from 'src/types'

export const useProfileStorage = () => {
  const saveProfileToLocalStorage = (profile: ProfileEntity): void => {
    if (isServer) {
      throw new Error("don't call in SSR for save profile to local storage.")
    }

    ProfileRepository.saveUserIdToLocalStorage(profile.id)
    ProfileRepository.saveUserRoleToLocalStorage(profile.role.name)
  }

  const loadProfileFromLocalStorage = (): { profileId: number; roleName: string } | null => {
    if (isServer) {
      throw new Error("don't call in SSR for load profile to local storage.")
    }

    const profileId = ProfileRepository.loadUserIdToLocalStorage()
    const roleName = ProfileRepository.loadUserRoleToLocalStorage()

    return profileId && roleName ? { profileId, roleName } : null
  }

  const removeProfileFromLocalStorage = (): void => {
    if (isServer) {
      throw new Error("don't call in SSR for remove profile to local storage.")
    }

    ProfileRepository.removeUserIdFromLocalStorage()
    ProfileRepository.removeUserRoleFromLocalStorage()
  }

  return {
    saveProfileToLocalStorage,
    loadProfileFromLocalStorage,
    removeProfileFromLocalStorage,
  }
}
